import BackgroundColors from '@root/joinroot.com/src/utils/background-colors';
import BrandBling, { BRAND_BLING_OPTIONS } from '@root/joinroot.com/src/components/brand-bling';
import Image from '@root/website-tooling/gatsby-image';
import LinkButton from '@root/joinroot.com/src/components/buttons/link-button';
import PropTypes from '@root/vendor/prop-types';
import Responsive from '@root/core/src/utils/responsive';
import { Eyebrow, H1Display, Subhead } from '@root/joinroot.com/src/components/text';
import { StyleSheet } from '@root/core/src/utils/styles';

export default function HeroImageTop({
  anchor,
  buttons,
  form,
  eyebrow,
  gatsbyImage,
  imageAlt,
  headline,
  brandBlingOptions = BRAND_BLING_OPTIONS.NONE,
  subhead,
  backgroundColor = BackgroundColors.cmsValues.WHITE,
  buttonComponent = LinkButton,
}) {
  const ButtonComponent = buttonComponent;

  let renderButtons = false;
  let renderForm = false;

  if (buttons.length > 0) {
    renderButtons = true;
  } else if (form) {
    renderForm = true;
  }

  return (
    <section
      css={[
        stylesBase.heroSection,
        BackgroundColors.getBackgroundStyle(backgroundColor),
      ]}
      id={anchor}
    >
      <div className={'wrap_image'}>
        <Image
          alt={imageAlt}
          className={'bgImage'}
          fluid={gatsbyImage}
          loading={'eager'}
        />
        <BrandBling brandBlingOptions={brandBlingOptions} />
      </div>

      <div className={'wrap_content'}>
        <div className={'container_content'}>
          {eyebrow && <Eyebrow className={'eyebrow'}>{eyebrow}</Eyebrow>}
          {headline && <H1Display className={'headline'}>{headline}</H1Display>}
          {subhead && <Subhead className={'subhead'}>{subhead}</Subhead>}
          {renderButtons && (
            <div className={'container_cta'}>
              {buttons.map((btn, i) => (
                <ButtonComponent
                  buttonStyles={buttonStyles}
                  key={i}
                  onClick={btn.onClick}
                  to={btn.link}
                  type={btn.type}
                >
                  {btn.text}
                </ButtonComponent>
              ))}
            </div>
          )}
          {renderForm && form}
        </div>
      </div>
    </section>
  );
}

HeroImageTop.propTypes = {
  analytics: PropTypes.object,
  anchor: PropTypes.string,
  backgroundColor: PropTypes.oneOf(BackgroundColors.cmsValueList),
  brandBlingOptions: PropTypes.oneOf(Object.values(BRAND_BLING_OPTIONS)).isRequired,
  buttonComponent: PropTypes.func,
  buttons: PropTypes.arrayOf(PropTypes.object),
  eyebrow: PropTypes.string,
  form: PropTypes.node,
  gatsbyImage: PropTypes.object.isRequired,
  headline: PropTypes.string.isRequired,
  imageAlt: PropTypes.string,
  subhead: PropTypes.string,
};

const stylesBase = StyleSheet.create({
  heroSection: {
    position: 'relative',

    '.wrap_image': {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-end',
      width: '100%',
      height: 180,

      '.bgImage': {
        width: '100%',
        height: 180,
      },

      ...Responsive.md({
        height: 330,

        '.bgImage': {
          height: 330,
        },
      }),
    },

    '.wrap_content': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',

      '.container_content': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        maxWidth: 1200,
        padding: '80px 20px',
        textAlign: 'center',

        ...Responsive.md({
          padding: '100px 20px',
        }),

        '.eyebrow': {
          maxWidth: 350,
        },

        '.headline, .subhead': {
          maxWidth: 550,

          ...Responsive.md({
            maxWidth: 800,
          }),
        },

        '.eyebrow, .headline, .subhead': {
          marginBottom: 12,
        },

        '.container_cta': {
          display: 'flex',
          flexDirection: 'column',
          margin: '30px -10px 0', // -10px accounts for margin on cta elements within.
          width: '100%',
          maxWidth: 260,

          ...Responsive.md({
            justifyContent: 'center',
            flexDirection: 'row',
            maxWidth: 480,
          }),
        },
      },
    },
  },
});

const buttonStyles = {
  margin: 10,
};
